import DataCatatanEdukasi from "@/services/DataCatatanEdukasi";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";

/** Objek opsi tunggal (data lama) -> array; nilai kosong/nyasar -> []. */
function toOptionArray(val) {
  if (Array.isArray(val)) return val;
  if (val && typeof val === "object" && val.id !== undefined) return [val];
  return [];
}

let regDiminta = "";

@Module({ store, dynamic: true, name: "storeCatatanEdukasi" })
class StoreCatatanEdukasi extends VuexModule {
  catatanEdukasi = {}

  @Mutation SET_CATATAN_EDUKASI(catatanEdukasi = {}) {
    this.catatanEdukasi = catatanEdukasi;
  }

  @Action clear() {
    this.SET_CATATAN_EDUKASI({});
  }

  @Action actCatatanEdukasi(reg) {
    regDiminta = String(reg || "");
    this.SET_CATATAN_EDUKASI({});
    const dt = DataCatatanEdukasi.getDataCatatanEdukasi(reg);
    appModule.setLoading(true);
    dt.then(dt => {
      appModule.setLoading(false);
      if (regDiminta !== String(reg || "")) return;
      const data = dt.data
      const kosong = {
        kebutuhan_edukasi: {
          tinggal: "",
          tinggal_lain: "",
          hambatan_edukasi: "",
          hambatan_list: [],
          hambatan_lain: "",
          penerima: [],
          penerima_lain: "",
          penerima_hubungan: "",
          agama: "",
          agama_lain: "",
          pendidikan: "",
          pendidikan_lain: "",
          pekerjaan: "",
          pekerjaan_lain: "",
          bahasa: "",
          bahasa_lain: "",
          penterjemah: "",
          bacatulis: "",
          nilai_status: "",
          nilai: "",
          kesediaan: "",
          hambatan_komunikasi: [],
          hambatan_komunikasi_lain: "",
          hambatan_emosi: [],
          bahasa_isyarat: "",
          pendamping_keluarga: "",
          pendidikan_kesehatan: [],
          pendidikan_kesehatan_lain: "",
          bahasa_sehari: [],
          bahasa_daerah_jelaskan: "",
          bahasa_lain_jelaskan: "",
        },
        edukasi_kolaborasi: [
          {
            profesi: "Dokter",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Nutrisionist",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Manajemen Nyeri",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Penggunaan Alat Medis",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Farmasi",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Perawat",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Rehabilitasi Medik",
            topik: "",
            diagnosa: "",
          },
          {
            profesi: "Rohaniawan Care",
            topik: "",
            diagnosa: "",
          },
        ],
        pelaksanaan_edukasi: [
          {
            profesi: "Dokter",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Penjelasan Penyakit, penyebab, tanda gejala, prognosa & Terapi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Hasil Pemeriksaan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Hasil Pengobatan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Rencana Penatalaksanaan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Hasil yang tak diharapkan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Tindakan medis",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Perkiraan hari rawat",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Komplikasi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Informed Consent",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Persiapan operasi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Prosedur pemeriksaan penunjang",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Manajemen Nyeri",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
          {
            profesi: "Perawat",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Pencegahan infeksi : cuci tangan,etika batuk, cara buang sampah",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Pemakaian gelang",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Rencana Asuhan keperawatan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Perawatan luka",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Keamanan penggunaan alat kesehatan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Tindakan tidak perlu inform consent",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Managemen nyeri",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Orientasi ruangan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Inform consent",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Persiapan operasi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Prosedur pemeriksaan penunjang",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Managemen Nyeri",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
          {
            profesi: "Farmasi",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Aturan & cara pemakaian obat",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Efek samping obat",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Potensi interaksi obat",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Nama obat, kegunaan, cara pemberian",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
          {
            profesi: "Nutrisionist",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Diet dan nutrisi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Konsultasi gizi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Pengelolaan makanan dari luar RS",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
          {
            profesi: "Rehabilitasi Medik",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Program & teknik terapi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Penerapan keamanan alat terapi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Pemeliharaan, pemakaian dan keamanan orthose protesa",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Komunikasi perilaku menelan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Managemen nyeri non farmakologis",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Home program",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
          {
            profesi: "Manajemen Nyeri",
            data_lain: [],
            data: [],
          },
          {
            profesi: "Penggunaan Alat Medis",
            data_lain: [],
            data: [],
          },
          {
            profesi: "Rohaniawan Care",
            data_lain: [],
            data: [],
          },
          {
            profesi: "MPP",
            data_lain: [],
            data: [],
          },
          {
            profesi: "Administrasi",
            data_lain:[],
            data:[],
            // data: [
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Tata tertib RS",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Hak berpartisipasi dalam pelayanan",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Hak dan kewajiban pasien /keluarga",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   {
            //     id: "",
            //     time: "",
            //     lama: "",
            //     nama: "Pengurusan administrasi",
            //     penerima: "",
            //     penerima_lain: "",
            //     metode: "",
            //     evaluasi: "",
            //     pemberi: "",
            //     nama_penerima: ""
            //   },
            //   // {
            //   //   id: "",
            //   //   time: "",
            //   //   lama: "",
            //   //   nama: "Edukasi Lainnya",
            //   //   penerima: "",
            //   //   metode: "",
            //   //   evaluasi: "",
            //   //   pemberi: "",
            //   //   nama_penerima: ""
            //   // },
            // ],
          },
        ],
      }
      if (data.length > 0) {
        const loaded = data[0];
        loaded.kebutuhan_edukasi = loaded.kebutuhan_edukasi || {};
        // Auto-migrate penerima (objek tunggal lama) -> array
        if (!Array.isArray(loaded.kebutuhan_edukasi.penerima)) {
          loaded.kebutuhan_edukasi.penerima = toOptionArray(
            loaded.kebutuhan_edukasi.penerima
          );
        }
        if (!Array.isArray(loaded.kebutuhan_edukasi.hambatan_komunikasi)) {
          loaded.kebutuhan_edukasi.hambatan_komunikasi = [];
        }
        if (loaded.kebutuhan_edukasi.hambatan_komunikasi_lain === undefined) {
          loaded.kebutuhan_edukasi.hambatan_komunikasi_lain = "";
        }
        if (!Array.isArray(loaded.kebutuhan_edukasi.hambatan_emosi)) {
          loaded.kebutuhan_edukasi.hambatan_emosi = [];
        }
        if (loaded.kebutuhan_edukasi.bahasa_isyarat === undefined) {
          loaded.kebutuhan_edukasi.bahasa_isyarat = "";
        }
        if (loaded.kebutuhan_edukasi.pendamping_keluarga === undefined) {
          loaded.kebutuhan_edukasi.pendamping_keluarga = "";
        }
        if (!Array.isArray(loaded.kebutuhan_edukasi.pendidikan_kesehatan)) {
          loaded.kebutuhan_edukasi.pendidikan_kesehatan = [];
        }
        if (loaded.kebutuhan_edukasi.pendidikan_kesehatan_lain === undefined) {
          loaded.kebutuhan_edukasi.pendidikan_kesehatan_lain = "";
        }
        if (loaded.kebutuhan_edukasi.pekerjaan === undefined) {
          loaded.kebutuhan_edukasi.pekerjaan = "";
        }
        if (loaded.kebutuhan_edukasi.pekerjaan_lain === undefined) {
          loaded.kebutuhan_edukasi.pekerjaan_lain = "";
        }
        // Auto-migrate legacy bahasa (single object) -> bahasa_sehari (array)
        if (!Array.isArray(loaded.kebutuhan_edukasi.bahasa_sehari)) {
          loaded.kebutuhan_edukasi.bahasa_sehari = [];
          const legacyBahasa = loaded.kebutuhan_edukasi.bahasa;
          if (legacyBahasa && typeof legacyBahasa === "object" && legacyBahasa.id !== undefined) {
            const mapBahasaLegacy = {
              "1": { id: "indonesia", nama: "Indonesia, aktif / pasif" },
              "2": { id: "inggris", nama: "Inggris, aktif / pasif" },
              "3": { id: "lain", nama: "Lain-lain" },
              "D": { id: "daerah", nama: "Daerah" },
              "0": { id: "lain", nama: "Lain-lain" }
            };
            const mapped = mapBahasaLegacy[legacyBahasa.id];
            if (mapped) {
              loaded.kebutuhan_edukasi.bahasa_sehari = [mapped];
            }
          }
        }
        if (loaded.kebutuhan_edukasi.bahasa_daerah_jelaskan === undefined) {
          loaded.kebutuhan_edukasi.bahasa_daerah_jelaskan = "";
        }
        if (loaded.kebutuhan_edukasi.bahasa_lain_jelaskan === undefined) {
          loaded.kebutuhan_edukasi.bahasa_lain_jelaskan =
            loaded.kebutuhan_edukasi.bahasa_lain || "";
        }
        // Auto-migrate per-entry metode/evaluasi single -> array
        const metodeMapLegacy = {
          "1": { id: "C", metode: "Ceramah (C)" },
          "2": { id: "C", metode: "Ceramah (C)" },
          "3": { id: "demo", metode: "Demonstrasi (demo)" }
        };
        if (Array.isArray(loaded.pelaksanaan_edukasi)) {
          loaded.pelaksanaan_edukasi.forEach(p => {
            if (Array.isArray(p.data)) {
              p.data.forEach(entry => {
                if (entry.metode && !Array.isArray(entry.metode)) {
                  if (typeof entry.metode === "object" && entry.metode.id !== undefined) {
                    const mig = metodeMapLegacy[entry.metode.id];
                    entry.metode = mig ? [mig] : [entry.metode];
                  } else {
                    entry.metode = [];
                  }
                } else if (!entry.metode) {
                  entry.metode = [];
                }
                // Evaluasi respon kembali single-select: array lama -> ambil pilihan pertama
                entry.evaluasi = toOptionArray(entry.evaluasi)[0] || "";
                entry.penerima = toOptionArray(entry.penerima);
              });
            }
          });
        }
        const expectedProfesi = [
          "Manajemen Nyeri",
          "Penggunaan Alat Medis",
          "Rohaniawan Care",
          "MPP"
        ];
        if (Array.isArray(loaded.pelaksanaan_edukasi)) {
          const existingNames = loaded.pelaksanaan_edukasi.map(p => p.profesi);
          expectedProfesi.forEach(nm => {
            if (!existingNames.includes(nm)) {
              loaded.pelaksanaan_edukasi.push({
                profesi: nm,
                data_lain: [],
                data: []
              });
            }
          });
        }
        this.SET_CATATAN_EDUKASI(loaded);
      } else {
        this.SET_CATATAN_EDUKASI(kosong)
      }
    });
  }
}

export const storeCatatanEdukasi = getModule(StoreCatatanEdukasi);
